<template>
  <button
    @click="profileAction"
    class="w-10 h-10 bg-white rounden flex justify-center items-center shadow-custom"
    type="button"
  >
    <IconUser></IconUser>
  </button>
</template>

<script>
import IconUser from '@icons/IconUser.vue';
export default {
  name: 'ProfileButton',
  components: {
    IconUser,
  },
  data() {
    return {};
  },
  methods: {
    profileAction() {
      if (this.$store.authStatus) {
        if (this.$store.userData?.has_business_account) {
          this.$router.push({ path: '/profile/myBusinessPublications' });
        } else {
          this.$router.push({ path: '/profile/myPublications' });
        }
      } else {
        this.$store.setState('loginModal', true);
      }
    },
  },
  computed: {},
  created() {},
};
</script>
